'use client';

import React from 'react';
import type { ComponentPropsWithoutRef } from 'react';
import { cx } from '../../../utils/cx';
import { MenuItemBase } from './MenuItemBase';
import type { MenuSize } from './menuTypes';

const MENU_FOOTER_DISPLAY_NAME = 'RomaMenuFooter';

const footerStyles = {
    root: 'shrink-0 border-t border-primary_alpha px-1.5 pt-1 pb-1.5',
    item: 'cursor-default rounded-none select-auto',
};

export type MenuFooterProps = ComponentPropsWithoutRef<'div'> & {
    size?: MenuSize;
};

/**
 * Displays footer content at the same vertical rhythm as menu rows.
 */
export const MenuFooter: React.FC<MenuFooterProps> = ({ size = 'sm', className, children, ...props }) => (
    <div {...props} className={cx(MENU_FOOTER_DISPLAY_NAME, footerStyles.root, className)}>
        <MenuItemBase size={size} className={footerStyles.item}>
            {children}
        </MenuItemBase>
    </div>
);

MenuFooter.displayName = MENU_FOOTER_DISPLAY_NAME;
